import { render, staticRenderFns } from "./share-files.vue?vue&type=template&id=30835664&scoped=true"
import script from "./share-files.vue?vue&type=script&lang=js"
export * from "./share-files.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30835664",
  null
  
)

export default component.exports